export default __webpack_public_path__ + "static/media/back_bold_gray.57779376.svg";